if (!window.reaHoverVideoInit) {
  window.reaHoverVideoInit = true;

  // Matches the min-width: 990px guard on the CSS crossfade (base.css) —
  // touch devices report pointerover on tap, and a stuck :hover state could
  // otherwise trigger playback on mobile, which has no real hover concept.
  const hoverCapable = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const play = (card) => {
    const video = card.querySelector('.card__hover-video');
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.play().catch(() => {});
  };

  const stop = (card) => {
    const video = card.querySelector('.card__hover-video');
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  };

  // Delegate on the same element the CSS crossfade keys off (.card-wrapper:hover),
  // not the video itself, so entering the card anywhere (badge, title, price) still
  // triggers playback. relatedTarget check emulates mouseenter/mouseleave semantics
  // so moving between children inside the card doesn't repeatedly restart it.
  document.addEventListener('pointerover', (event) => {
    if (!hoverCapable()) return;
    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    play(card);
  });

  document.addEventListener('pointerout', (event) => {
    if (!hoverCapable()) return;
    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    stop(card);
  });
}
